import React from 'react';
import DokanIcons from '../icon/DokanIcons';

const DokanTableItemRating = ({ ratingCount }) => (
    <>
        <div className="flex pb-5px">
            <DokanIcons icon="#star" size={4} />
            <span className="pl-10px text-secondary text-base">{ratingCount}</span>
        </div>
        <div className="flex pt-5px">
            <DokanIcons icon="#message" size={4} />
            <span className="pl-10px text-secondary text-base">{ratingCount}</span>
        </div>
    </>
);

export default DokanTableItemRating;
